import { render, staticRenderFns } from "./T-F-Under-Grad-2025.vue?vue&type=template&id=3c9884c2&scoped=true"
import script from "./T-F-Under-Grad-2025.vue?vue&type=script&lang=js"
export * from "./T-F-Under-Grad-2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9884c2",
  null
  
)

export default component.exports